import { Link } from "react-router-dom";
import { quickEntries } from "@/mocks/genres";

export default function QuickEntries() {
  return (
    <section className="mx-auto w-full max-w-8xl px-4 md:px-6">
      <div className="-mt-8 relative z-10 rounded-lg border border-background-200 bg-background-50 p-4 md:-mt-10 md:p-5">
        <div className="grid grid-cols-4 gap-2 md:grid-cols-8 md:gap-3">
          {quickEntries.map((entry) => (
            <Link
              key={entry.label}
              to={entry.to}
              className="group flex flex-col items-center gap-2 rounded-md px-2 py-3 transition-colors hover:bg-primary-50"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-background-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${entry.icon} text-xl`}></i>
              </span>
              <span className="text-xs font-semibold text-foreground-700 transition-colors group-hover:text-primary-700 md:text-sm">
                {entry.label}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}